import { render, staticRenderFns } from "./AddFcStoringAgent.vue?vue&type=template&id=4bbc396d"
import script from "./AddFcStoringAgent.vue?vue&type=script&lang=js"
export * from "./AddFcStoringAgent.vue?vue&type=script&lang=js"
import style0 from "./AddFcStoringAgent.vue?vue&type=style&index=0&id=4bbc396d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports